import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'

interface Props {
  vm: JobProgressionViewModel
}
export default observer(function AuthorizationRequestedProgressionActions({
  vm,
}: Props) {
  return (
    <>
      <CardContent compactBottomPadding={vm.isAnyExtensionFlowAvailable}>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.answerAuthorizationSigned()}
          dataTest="job-progression-set-authorization-received-button"
        >
          Authorization Received
        </Button>
      </CardContent>

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} isSecondary />
      )}
    </>
  )
})
